<div class="lightbox" (click)="fechar()">
	<button mat-icon-button class="botao-fechar" (click)="fechar(); $event.stopPropagation()">
		<mat-icon>close</mat-icon>
	</button>
	<swiper-container
		#lightboxSwiper
		class="lightbox-swiper"
		(click)="$event.stopPropagation()"
		[attr.initial-slide]="index"
		[attr.zoom]="true"
		[attr.navigation]="images.length > 1 || null">
		@for (image of images; track $index) {
		<swiper-slide>
			<div class="swiper-zoom-container">
				<img [src]="image.image" class="imagem-ampliada">
			</div>
		</swiper-slide>
		}
	</swiper-container>
</div>
